import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {VisibilityIcon} from "./visibilityIcon";

export const DOBDisplay = ({dob, label = 'Date of birth', isVerticalLayout = false, name, visibilityIconVisible = true}) => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => setIsVisible(prevIsVisible => !prevIsVisible);

    const maskDob = () => isVisible ? dob : dob.replace(/\d{4}$/, '••••');

    const labelContent = <b>{label} {(dob && visibilityIconVisible) && <VisibilityIcon ariaLabel={"date of birth"} isVisible={isVisible} onClick={toggleVisibility}/>}</b>;

    return isVerticalLayout ? (
        <>
            {labelContent}<br/>
            {name}<br/>
            {`(${maskDob(dob)})`}
        </>
    ) : (
        <>
            {labelContent}
            <div>{maskDob(dob)}</div>
        </>
    );
};

DOBDisplay.propTypes = {
    label: PropTypes.string,
    isVerticalLayout: PropTypes.bool,
    dob: PropTypes.string.isRequired,
    name: function (props, propName) {
        if (props.isVerticalLayout && (!props[propName] || typeof (props[propName]) !== 'string')) {
            return new Error(`Prop ${propName} is required and it should be a string when isVerticalLayout is true`);
        }
    },
    visibilityIconVisible: PropTypes.bool,
};
